import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthStorage} from '../core/auth/auth-storage';
import {AuthConfig} from '../core/auth/auth-config';
import {map, Observable, of} from 'rxjs';
import {ChatService} from '../core/component/chat/chat.service';
import {Router} from '@angular/router';
import {AlarmsWebSocketService} from '../core/ws/alarms-web-socket.service';
import {ChatWebSocketService} from '../core/ws/chat-web-socket.service';
import {AssetsStateWebSocketService} from '../core/ws/assets-state/assets-state-web-socket.service';
import {PasswordReminderRequest} from './password-reminder/model/password-reminder.request';
import {catchError} from 'rxjs/operators';
import {NotificationService} from '../core/notification/notification.service';

@Injectable()
export class AuthService {

  constructor(private http: HttpClient,
              private chatService: ChatService,
              private alarmsWSService: AlarmsWebSocketService,
              private chatWSService: ChatWebSocketService,
              private assetsStateWsService: AssetsStateWebSocketService,
              private router: Router,
              private notification: NotificationService) {
  }

  public remindPassword(request: PasswordReminderRequest, locale: string, token: string): Observable<string> {
    let headers = new HttpHeaders().set('reCaptcha-token', token);
    return this.http.post<string>(`/api/auth/password-remind?locale=${locale}`, request, {headers: headers});
  }

  public resetPassword(token: string, request: string): Observable<string>{
    return this.http.post<string>(`/api/admin/auth/reset-password?token=${token}`, request);
  }

  public checkResetToken(token: string): Observable<string> {
    return this.http.get<string>(`/api/admin/auth/reset-password?token=${token}`);
  }

  public updateTokens(): Observable<string> {
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Accept', 'application/json');

    let request = 'client_id='
      + AuthConfig.CLIENT_ID
      + '&grant_type=refresh_token&refresh_token='
      + AuthStorage.refreshToken();
    return this.http.post<string>('/oauth2/token', request, {headers: headers})
      .pipe(map(data => {
            AuthStorage.persistTokens(data['access_token'], data['refresh_token']);
            // let decodedToken = new JwtHelperService().decodeToken(data['access_token']);
            // AuthStorage.persistPasswordExpiration(decodedToken['password-expired'])
            // if (decodedToken['requires-relog'] === true) {
            //   this.logOut();
            // }
            // if (decodedToken['password-expired']) {
            //   this.router.navigate([AuthConfig.CHANGE_PASSWORD_ROUTE]);
            // }
            return AuthStorage.accessToken();
          }
        ),
        catchError((err) => {
          this.logOut();
          this.notification.info("global.error.sessionExpired")
          return of()
        }));
  }

  public loginAfterVerification(request: any): Observable<Object> {
    return this.http.post<Object>(`/api/auth/verify-code?verificationCode`, request)
  }

  public logOut(): void {
    AuthStorage.clearTokens();
    this.chatService.closeChat();
    this.alarmsWSService.disconnect();
    this.chatWSService.disconnect();
    this.assetsStateWsService.disconnect();
    this.router.navigate([AuthConfig.LOGIN_ROUTE]);
  }

  public isPasswordExpired(): Observable<boolean> {
    return this.http.get<boolean>('/api/auth/is-password-expired');
  }

  public verifyTwoFactorLogin(email: string, code: string): Observable<boolean> {
    return this.http.post<boolean>('/oauth/2fa/verify', {email, code});
  }
}
